import { h, cloneElement } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
// import s from 'base/bolt/boltApp.sss';

if (typeof window !== 'undefined') {
	const qs = new URLSearchParams(location.search);
	const widget = qs.get('a11y-widget');
	// TODO: remove once test period is over
	if (widget === 'userway') {
		let el = document.createElement('script');
		el.setAttribute('data-account', 'grMgHwmJuX');
		el.setAttribute('src', 'https://cdn.userway.org/widget.js');
		document.body.appendChild(el);
	} else if (widget !== 'none') {
		import('utils/accessibilityTools').then(({ init }) => init());
	}
}

export default class BoltApp extends BaseComp.default {
	renderMain(props, state) {
		const main = super.renderMain(props, state);
		return cloneElement(main, { role: 'main' });
	}
}
